import React from "react";

const ShimmerCard = () => {
	return (
		<div className="bg-gray-100 dark:bg-gray-800 shadow rounded-2xl p-6 w-full max-w-md animate-pulse">
			<div className="h-5 bg-gray-300 dark:bg-gray-700 rounded w-1/2 mx-auto mb-6"></div>
			<div className="w-full h-64 bg-gray-200 dark:bg-gray-700 rounded-lg"></div>
		</div>
	);
};

export default ShimmerCard;
